/* eslint-disable import/no-cycle */
// External deps
import axios from 'axios';

// Internal deps
import { userInfo } from '../resources/environmentConstants';
import encrypt from '../utils/encrypt';

import { apiYclickMaster } from './apiInstances';

export const getUserInfo = async (access_token) => {
  try {
    const result = await axios.post(userInfo, null, {
      headers: {
        Authorization: `Bearer ${access_token}`
      }
    });

    return result.data;
  } catch (e) {
    return null;
  }
};

export const loginService = async (params) => {
  const { userName, password } = params;
  const encryptedPassword = encrypt(password);
  const encryptedUserName = encrypt(userName);

  const response = await apiYclickMaster.post('/v1/login', {
    userName: encryptedUserName,
    password: encryptedPassword
  });

  return response.data;
};
